(function () {
  var SECTION_SELECTOR = '.oddit-section-featured-press';
  var sectionState = new Map();
  var sectionCounter = 0;

  function initPress(section) {
    var viewport = section.querySelector('[data-press-viewport]');
    var track = section.querySelector('[data-press-track]');
    var dotsContainer = section.querySelector('[data-press-dots]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-press-slide]'));
    var dots = [];
    if (!viewport || !track || !dotsContainer || slides.length === 0) return null;

    var state = {
      currentPage: 0,
      slidesPerPage: 1,
      pageCount: 1,
      slideWidth: 0,
      gap: 0,
      pageStride: 0,
      maxTranslate: 0,
      autoplayPaused: false,
      autoplayTimer: null,
      reducedMotionMql: window.matchMedia('(prefers-reduced-motion: reduce)')
    };

    function setActiveDot(pageIdx) {
      for (var i = 0; i < dots.length; i++) {
        if (i === pageIdx) {
          dots[i].classList.add('oddit-section-featured-press__dot--active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('oddit-section-featured-press__dot--active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function buildDots() {
      if (dots.length === state.pageCount) return;
      dotsContainer.textContent = '';
      dots = [];
      for (var i = 0; i < state.pageCount; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oddit-section-featured-press__dot';
        btn.setAttribute('data-press-dot', '');
        btn.setAttribute('data-slide-index', String(i));
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        var span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = '&zwnj;';
        btn.appendChild(span);
        (function (index) {
          btn.addEventListener('click', function () {
            goToPage(index);
            resetAutoplayTimer();
          });
        })(i);
        dotsContainer.appendChild(btn);
        dots.push(btn);
      }
      dotsContainer.hidden = state.pageCount <= 1;
    }

    function measureLayout() {
      var slideRect = slides[0].getBoundingClientRect();
      var slideWidth = slideRect.width;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var trackPadRight = parseFloat(styles.paddingRight) || 0;
      var viewportWidth = viewport.clientWidth;

      if (slideWidth <= 0 || viewportWidth <= 0) return false;

      // Count only slides that fit FULLY in the viewport. A 1px tolerance
      // absorbs sub-pixel rounding so an exact fit doesn't drop a slide.
      var perPage = Math.max(1, Math.floor((viewportWidth + gap + 1) / (slideWidth + gap)));
      perPage = Math.min(perPage, slides.length);
      var totalContent = slides.length * slideWidth + (slides.length - 1) * gap + trackPadRight;
      var maxTranslate = Math.max(0, totalContent - viewportWidth);
      // Advance one slide per page so the leftmost slide always aligns to the
      // viewport edge (and the section's eyebrow). Clamping to a page-wide
      // stride at the end would land between slides.
      var pageStride = slideWidth + gap;

      var pageCount;
      if (maxTranslate <= 0.5 || pageStride <= 0) {
        pageCount = 1;
      } else {
        pageCount = Math.max(1, slides.length - perPage + 1);
      }

      state.slideWidth = slideWidth;
      state.gap = gap;
      state.slidesPerPage = perPage;
      state.pageCount = pageCount;
      state.pageStride = pageStride;
      state.maxTranslate = maxTranslate;
      return true;
    }

    function getPageOffset(pageIdx) {
      // Don't clamp to maxTranslate — keep slide-aligned offsets so the
      // leftmost slide always sits at the viewport edge (under the eyebrow),
      // even on the last page where there may be a little empty space on the
      // right.
      var desired = pageIdx * state.pageStride;
      if (desired < 0) desired = 0;
      return desired;
    }

    function applyTransform(translateX) {
      state.currentTranslate = translateX;
      track.style.transform = 'translate3d(' + (-translateX) + 'px, 0, 0)';
    }

    var rewindTimer = null;

    function goToPage(pageIdx, opts) {
      opts = opts || {};
      if (pageIdx < 0) pageIdx = 0;
      if (pageIdx >= state.pageCount) pageIdx = state.pageCount - 1;
      var offset = getPageOffset(pageIdx);

      // Any new navigation cancels an in-flight rewind so we don't get a stuck class.
      if (rewindTimer) {
        clearTimeout(rewindTimer);
        rewindTimer = null;
        track.classList.remove('oddit-section-featured-press__track--rewind');
      }

      if (opts.instant) {
        track.classList.add('oddit-section-featured-press__track--no-transition');
        applyTransform(offset);
        void track.offsetWidth;
        requestAnimationFrame(function () {
          track.classList.remove('oddit-section-featured-press__track--no-transition');
        });
      } else if (opts.rewind) {
        track.classList.add('oddit-section-featured-press__track--rewind');
        applyTransform(offset);
        rewindTimer = setTimeout(function () {
          track.classList.remove('oddit-section-featured-press__track--rewind');
          rewindTimer = null;
        }, 750);
      } else {
        applyTransform(offset);
      }

      state.currentPage = pageIdx;
      setActiveDot(pageIdx);
      setActiveSlides(pageIdx);
    }

    function setActiveSlides(pageIdx) {
      var firstActive = pageIdx;
      var lastActive = pageIdx + state.slidesPerPage - 1;
      for (var i = 0; i < slides.length; i++) {
        var isActive = i >= firstActive && i <= lastActive;
        slides[i].classList.toggle('oddit-section-featured-press__slide--active', isActive);
      }
    }

    function nextPage() {
      if (state.currentPage >= state.pageCount - 1) {
        goToPage(0, { rewind: true });
      } else {
        goToPage(state.currentPage + 1);
      }
    }

    /* ---------- Autoplay ---------- */

    function startAutoplay() {
      if (state.autoplayTimer) return;
      if (state.reducedMotionMql.matches) return;
      if (state.pageCount <= 1) return;
      var seconds = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5;
      var intervalMs = seconds * 1000;
      state.autoplayTimer = setInterval(function () {
        if (!state.autoplayPaused) nextPage();
      }, intervalMs);
    }

    function stopAutoplay() {
      if (state.autoplayTimer) {
        clearInterval(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    function pauseAutoplay() { state.autoplayPaused = true; }
    function resumeAutoplay() { state.autoplayPaused = false; }

    function resetAutoplayTimer() {
      var wasRunning = !!state.autoplayTimer;
      stopAutoplay();
      if (wasRunning) startAutoplay();
    }

    /* ---------- Drag / swipe ---------- */

    var drag = {
      active: false,
      pointerId: null,
      startX: 0,
      startY: 0,
      lastX: 0,
      startTranslate: 0,
      axisLocked: false,
      isHorizontal: false,
      startTime: 0,
      suppressNextClick: false
    };

    var DRAG_DIRECTION_THRESHOLD = 6;
    var DRAG_DISTANCE_THRESHOLD = 40;
    var DRAG_VELOCITY_THRESHOLD = 0.35;

    function onPointerDown(e) {
      if (state.pageCount <= 1) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag.active = true;
      drag.pointerId = e.pointerId;
      drag.startX = e.clientX;
      drag.startY = e.clientY;
      drag.lastX = e.clientX;
      drag.startTranslate = state.currentTranslate || 0;
      drag.axisLocked = false;
      drag.isHorizontal = false;
      drag.startTime = (e.timeStamp || Date.now());
      pauseAutoplay();
    }

    function onPointerMove(e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;

      if (!drag.axisLocked) {
        if (Math.abs(dx) < DRAG_DIRECTION_THRESHOLD && Math.abs(dy) < DRAG_DIRECTION_THRESHOLD) return;
        drag.isHorizontal = Math.abs(dx) > Math.abs(dy);
        drag.axisLocked = true;
        if (!drag.isHorizontal) {
          // Vertical scroll — let the page take over.
          drag.active = false;
          resumeAutoplay();
          return;
        }
        try { viewport.setPointerCapture(drag.pointerId); } catch (err) {}
        viewport.classList.add('oddit-section-featured-press__viewport--dragging');
        track.classList.add('oddit-section-featured-press__track--no-transition');
      }

      drag.lastX = e.clientX;
      var next = drag.startTranslate - dx;
      // Soft clamp at edges so it feels bounded but not rigid.
      if (next < 0) next = next / 3;
      else if (next > state.maxTranslate) next = state.maxTranslate + (next - state.maxTranslate) / 3;
      applyTransform(next);
      if (e.cancelable) e.preventDefault();
    }

    function endDrag(e) {
      if (!drag.active || (e && e.pointerId !== drag.pointerId)) return;
      var wasHorizontal = drag.isHorizontal;
      drag.active = false;
      try { viewport.releasePointerCapture(drag.pointerId); } catch (err) {}
      drag.pointerId = null;
      viewport.classList.remove('oddit-section-featured-press__viewport--dragging');
      track.classList.remove('oddit-section-featured-press__track--no-transition');

      if (!wasHorizontal) {
        resumeAutoplay();
        return;
      }

      var dx = drag.lastX - drag.startX;
      if (Math.abs(dx) > DRAG_DIRECTION_THRESHOLD) drag.suppressNextClick = true;
      var elapsed = ((e && e.timeStamp) || Date.now()) - drag.startTime;
      var velocity = elapsed > 0 ? Math.abs(dx) / elapsed : 0;
      var target = state.currentPage;

      if (Math.abs(dx) > DRAG_DISTANCE_THRESHOLD || velocity > DRAG_VELOCITY_THRESHOLD) {
        target = dx < 0 ? state.currentPage + 1 : state.currentPage - 1;
      }

      if (target < 0) target = 0;
      if (target > state.pageCount - 1) target = state.pageCount - 1;
      goToPage(target);
      resetAutoplayTimer();
      resumeAutoplay();
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    // Swallow the synthetic click the browser fires after a drag-release,
    // so dragging onto a logo link doesn't navigate.
    viewport.addEventListener('click', function (e) {
      if (drag.suppressNextClick) {
        drag.suppressNextClick = false;
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* ---------- Resize ---------- */

    var resizeRaf = null;
    function recompute(opts) {
      if (!measureLayout()) return;
      buildDots();
      if (state.currentPage >= state.pageCount) state.currentPage = state.pageCount - 1;
      goToPage(state.currentPage, { instant: opts && opts.instant });
      if (state.pageCount <= 1) stopAutoplay();
    }

    function scheduleRecompute() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () { recompute({ instant: true }); });
    }

    window.addEventListener('resize', scheduleRecompute);

    var resizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(scheduleRecompute);
      resizeObserver.observe(viewport);
    }

    /* ---------- Visibility + reduced motion ---------- */

    function onVisibilityChange() {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    function onReducedMotionChange(e) {
      if (e.matches) stopAutoplay();
      else startAutoplay();
    }
    state.reducedMotionMql.addEventListener('change', onReducedMotionChange);

    /* ---------- Init ---------- */

    function tryInitLayout() {
      if (!measureLayout()) {
        requestAnimationFrame(tryInitLayout);
        return;
      }
      buildDots();
      goToPage(0, { instant: true });
      var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
      if (autoplayEnabled && !state.reducedMotionMql.matches) {
        startAutoplay();
      }
    }
    tryInitLayout();

    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { recompute({ instant: true }); }, { once: true });
    }

    state.destroy = function () {
      stopAutoplay();
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', scheduleRecompute);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      state.reducedMotionMql.removeEventListener('change', onReducedMotionChange);
    };

    return state;
  }

  function initSection(section) {
    if (!section.id) {
      sectionCounter += 1;
      section.id = 'oddit-section-featured-press-' + sectionCounter;
    }
    if (sectionState.has(section.id)) return;
    var state = initPress(section);
    if (state) sectionState.set(section.id, state);
  }

  function destroySection(section) {
    if (!section || !section.id) return;
    var state = sectionState.get(section.id);
    if (!state) return;
    if (state.destroy) state.destroy();
    sectionState.delete(section.id);
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
